import { AnalyticsEvents, ctaAttrs, freeConsultCtaLabel, getStartedCtaLabel } from '../../lib/analytics';

const headingFontFamilyStyle = { fontFamily: 'var(--font-heading)' };

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-storm text-white py-8 sm:py-12 md:py-16 px-4 sbi-shadow-xl relative overflow-hidden">
      {/* Subtle brand accent decoration */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-linear-to-r from-blue via-magenta to-sunshine"></div>

      <div className="max-w-7xl xl:max-w-[1400px] mx-auto">
        {/* Conversion Layer */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16 pb-12 border-b border-storm-400">
          <div className="p-6 rounded-xl bg-blue/20 border border-blue/40 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              SmallBiz Programs
            </h3>
            <p className="text-storm-200 text-sm mb-4">Our flagship offer. From $399/mo.</p>
            <a
              href="/programs"
              onClick={() => AnalyticsEvents.footerProgramsClicked()}
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Explore Programs &rarr;
            </a>
          </div>
          <div className="p-6 rounded-xl bg-storm-400/30 border border-storm-400 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              Get Started
            </h3>
            <p className="text-storm-200 text-sm mb-4">Ready to grow? Start your journey here.</p>
            <a
              href="/get-started"
              {...ctaAttrs(getStartedCtaLabel('footer-cards'))}
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Start Now &rarr;
            </a>
          </div>
          <div className="p-6 rounded-xl bg-storm-400/30 border border-storm-400 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              Free Consults
            </h3>
            <p className="text-storm-200 text-sm mb-4">Book a free virtual strategy session.</p>
            <a
              href="/free-consults"
              {...ctaAttrs(freeConsultCtaLabel('footer-cards'))}
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Book Now &rarr;
            </a>
          </div>
          <div className="p-6 rounded-xl bg-storm-400/30 border border-storm-400 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              Newsletter
            </h3>
            <p className="text-storm-200 text-sm mb-4">
              Get tips, insights, and updates delivered.
            </p>
            <a
              href="/newsletter"
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Subscribe &rarr;
            </a>
          </div>
          <div className="p-6 rounded-xl bg-storm-400/30 border border-storm-400 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              Contact
            </h3>
            <p className="text-storm-200 text-sm mb-4">Have questions? Chat with our team.</p>
            <a
              href="/contact"
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Get in Touch &rarr;
            </a>
          </div>
        </div>

        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Business Services */}
          <div>
            <h4 className="font-bold text-lg mb-4" style={headingFontFamilyStyle}>
              Business Services
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/programs"
                  onClick={() => AnalyticsEvents.footerProgramsClicked()}
                  className="text-sunshine hover:text-sunshine/80 transition-colors text-sm font-semibold"
                >
                  SmallBiz Programs
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  All Services
                </a>
              </li>
              <li>
                <a
                  href="/pricing"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="/on-demand-support"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  On-Demand Support
                </a>
              </li>
              <li>
                <a
                  href="/virtual-strategy-sessions"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Virtual Strategy Sessions
                </a>
              </li>
            </ul>
          </div>

          {/* About SmallBiz */}
          <div>
            <h4 className="font-bold text-lg mb-4" style={headingFontFamilyStyle}>
              About SmallBiz
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/about"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  SmallBiz Innovation
                </a>
              </li>
              <li>
                <a
                  href="/updates"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Company Updates
                </a>
              </li>
              <li>
                <a
                  href="/testimonials"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Testimonials
                </a>
              </li>
              <li>
                <a
                  href="/policies"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Policies
                </a>
              </li>
              <li>
                <a
                  href="/faqs"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  FAQs
                </a>
              </li>
            </ul>
          </div>

          {/* Client Services */}
          <div>
            <h4 className="font-bold text-lg mb-4" style={headingFontFamilyStyle}>
              Client Services
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/support-desk"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  SmallBiz Support Desk
                </a>
              </li>

            </ul>
          </div>

          {/* Get In Touch */}
          <div>
            <h4 className="font-bold text-lg mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              Get In Touch
            </h4>
            <ul className="space-y-2">
              <li className="text-storm-200 text-sm font-semibold">SmallBiz Innovation LLC</li>
              <li>
                <a
                  href="tel:+16502000828"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  (650) 200-0828
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@smallbizinnovation.com"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  hello@smallbizinnovation.com
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Contact / Open Chat
                </a>
              </li>
            </ul>
          </div>

          {/* Free Resources */}
          <div>
            <h4 className="font-bold text-lg mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              Free Resources
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/freebies"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Download Freebies
                </a>
              </li>
              <li>
                <a
                  href="/newsletter"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  SBI Pulse - Free Newsletter!
                </a>
              </li>
              <li>
                <a
                  href="/toolbox"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  SmallBiz ToolBox - Our Recs & Deals
                </a>
              </li>
              <li>
                <a
                  href="https://botstudio.smallbizinnovation.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  SmallBiz BotStudio - Gen AI Tools
                </a>
              </li>
              <li>
                <a
                  href="/free-consults"
                  {...ctaAttrs(freeConsultCtaLabel('footer-links'))}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Virtual Strategy Session - Free Consults!
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Brand Tagline */}
        <div className="text-center mb-8 pb-8 border-b border-storm-400">
          <div className="flex items-center justify-center space-x-2">
            <span className="text-2xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
              SmallBiz
            </span>
            <span className="text-2xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
              Innovation
            </span>
          </div>
          <p className="text-sunshine font-semibold mt-2">Strategy + Execution. One Partner.</p>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center text-sm">
          <p className="text-storm-200 mb-4 md:mb-0">©{currentYear} SmallBiz Innovation LLC</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/contact"
              className="text-storm-200 hover:text-sunshine transition-colors py-2"
            >
              Contact
            </a>
            <span className="text-storm-400">|</span>
            <a
              href="/policies"
              className="text-storm-200 hover:text-sunshine transition-colors py-2"
            >
              Policies
            </a>
            <span className="text-storm-400">|</span>
            <a href="/terms" className="text-storm-200 hover:text-sunshine transition-colors py-2">
              Terms
            </a>
            <span className="text-storm-400">|</span>
            <a
              href="/privacy"
              className="text-storm-200 hover:text-sunshine transition-colors py-2"
            >
              Privacy
            </a>
            <span className="text-storm-400">|</span>
            <a
              href="/cookies"
              className="text-storm-200 hover:text-sunshine transition-colors py-2"
            >
              Cookies
            </a>
            <span className="text-storm-400">|</span>
            <a href="/refund" className="text-storm-200 hover:text-sunshine transition-colors py-2">
              Refund
            </a>
            <span className="text-storm-400">|</span>
            <a
              href="/billing"
              className="text-storm-200 hover:text-sunshine transition-colors py-2"
            >
              Billing
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
